import { CommunitySwitcher } from "@circle-react/components/CommunitySwitcher/CommunitySwitcher";

export const CommunitySwitcherAppData = () => <CommunitySwitcher />;
